<template>
  <div id="app">

     <MainNavTop :items="items" @nav="navSelected"/>
    <Menu :open="menu_open"  :items="items" @nav="navSelected"/>

<div v-if="dev_mode">
    <div class="d-block d-sm-none">xs</div>
    <div class="d-none d-sm-block d-md-none">sm</div>
    <div class="d-none d-sm-block d-md-block">md</div>
    <div class="d-none d-sm-block d-md-none d-lg-block">lg</div>
    <div class="d-none d-sm-block d-md-none d-lg-none d-xl-block">xl</div>
</div>

   <div id="pages">
      <b-container id="home" class="page">
      <HelloWorld/>
    </b-container>

    <b-container>
      <b-row>
        <b-col md="6">
          <OurAim id="ouraim" class="page"/>
        </b-col>
        <b-col md="6">
          <OurHistory id="history" class="page"/>
        </b-col>
      </b-row>
    </b-container>

     <b-container id="services" class="page">
      <Services/>
     </b-container>

     <b-container id="contact" class="page">
      <Contact/>
     </b-container>
   </div>

  </div>
</template>

<script>
  import MainNavTop from './components/MainNavTop.vue'
  import Menu from './components/Menu.vue'
  import HelloWorld from './components/HelloWorld.vue'
  import OurAim from './components/OurAim.vue'
  import OurHistory from './components/OurHistory.vue'
  import Services from './components/Services.vue'
  import Contact from './components/Contact.vue'
  export default {
    name: 'app',
    props:{

    },
    data(){
      return {
        menu_open:false,
        dev_mode:false,
        views:[
          'xs','sm','md','lg','xl'
        ],
        items:{
          home:{
            name:'#home',
            active:true,
            title:'Home',
            wrap:false,
            icon:'home'
          },
          ouraim:{
            name:'#ouraim',
            active:false,
            title:'Our Aim',
            wrap:false,
            icon:'policy'
          },
          history:{
            name:'#history',
            active:false,
            title:'History',
            wrap:false,
            icon:'emoji_events'
          },
          services:{
            name:'#services',
            active:false,
            title:'Services',
            wrap:false,
            icon:'build'
          },
          contact:{
            name:'#contact',
            active:false,
            title:'Contact',
            wrap:false,
            icon:'phone'
          }
        }
      }
    },
    components: {
      MainNavTop,
      Menu,
      HelloWorld,
      OurAim,
      OurHistory,
      Services,
      Contact
    },
    methods:{
      navSelected(itemName){  
        if(itemName == 'open'){
          this.menu_open = !this.menu_open;
        }
        else{
            for(let prop in this.items){
            if(this.items[prop].name === itemName){
              this.items[prop].active = true;
            }else{
              this.items[prop].active = false;
            }
            this.menu_open = false;
          }
        }
      }
    }
  }
</script>